/**
 * ChurnMetrics - Churn & Retention Analysis section
 */
import React from 'react';
import { UserX, Users, DollarSign } from 'lucide-react';
import { MetricCard, MetricSubsection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function ChurnMetrics({ snapshotData }) {
  const summary = snapshotData?.summary || {};
  
  return (
    <>
      <MetricSubsection title="Churn & Retention Analysis">
        <MetricGrid cols={4}>
          <MetricCard
            icon={UserX}
            iconColor="bg-orange-100 dark:bg-orange-900/20"
            title="Non-Renewing Paid Users"
            value={formatValue(summary.totalNonRenewingPaidUsers || 0, 'number')}
            subtitle="will churn soon"
            subtitleColor="text-orange-600 dark:text-orange-400"
          />
          <MetricCard
            icon={UserX}
            iconColor="bg-red-100 dark:bg-red-900/20"
            title="Cancelling Soon"
            value={formatValue(summary.payingCustomersScheduledToCancel || 0, 'number')}
            subtitle="will cancel at period end"
            subtitleColor="text-red-600 dark:text-red-400"
          />
          <MetricCard
            icon={UserX}
            iconColor="bg-gray-100 dark:bg-gray-800"
            title="Deleted Paying"
            value={formatValue(summary.deletedPayingCustomers || 0, 'number')}
            subtitle="customers deleted"
          />
          <MetricCard
            icon={UserX}
            iconColor="bg-gray-100 dark:bg-gray-800"
            title="Deleted Trial"
            value={formatValue(summary.deletedTrialUsers || 0, 'number')}
            subtitle="trial users deleted"
          />
        </MetricGrid>
      </MetricSubsection>

      {/* Historical Metrics */}
      <MetricSubsection title="Historical Metrics">
        <MetricGrid cols={2}>
          <MetricCard
            icon={Users}
            iconColor="bg-blue-100 dark:bg-blue-900/20"
            title="Total Ever Acquired"
            value={formatValue(summary.totalCustomersEverAcquired || 0, 'number')}
            subtitle="lifetime customers"
          />
          <MetricCard
            icon={DollarSign}
            iconColor="bg-red-100 dark:bg-red-900/20"
            title="Lost Revenue"
            value={formatValue(summary.deletedUsersRevenue || 0, 'currency')}
            subtitle="from deleted accounts"
            subtitleColor="text-red-600 dark:text-red-400"
          />
        </MetricGrid>
      </MetricSubsection>
    </>
  );
}

